import { Button, Checkbox, FormControlLabel, Icon, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@mui/material';
import clsx from 'clsx';
import { ImageList } from 'global/components/image';
import { CenterContent, GridContainer, LeftSideBar, RightSideBar } from 'global/components/perform-grid';
import ScoreIcon from 'global/components/ScoreIcon';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { useVendors } from 'global/hooks/useVendors';
import { first, get, last, orderBy, set, size, uniqBy, unset } from 'global/lib/lodash';
import { Loading, useScreen } from 'global/styles';
import { getTaskImage, getTaskStatus, getTaskTradeTypes, getUrlParams } from 'global/utils';
import { buildFilters } from 'global/utils/filter';
import realmChange from 'global/wrappers/realmChange';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { userHasPermissions } from 'redux/actions/userLogin';
import { addNewTask, removeNewTask, setTaskList } from 'redux/actions/view';
import Modal from '../../../global/components/modal';
import { MoreList } from '../../../global/components/more-drop';
import { Row } from '../../../global/components/row';
import { Text } from '../../../global/components/text';
import { useView } from '../../../global/hooks/useView';
import { stopProp, taskNumToString, taskStringToNum } from '../../../global/utils';
import TaskFilters from '../Filters';
import TaskCreate from '../TaskCreate';
import { RenderTag } from '../TaskCreate/TaskCreate';
import { DetailModal } from '../TaskDetail';
import { CommentContainer } from '../TaskDetail/comments';
import MessageListItem from '../TaskList/MessageListItem';
import TaskListItem from '../TaskList/TaskListItem';
import TaskNotify from '../TaskNotify';
import useStyles from './TaskRealm.styles';

const include =
  'images,assessment,realm,authors,assignees,viewers,comments,scorecardScore,scorecardScore.checklist,scorecardScore.checkpoint,scorecardScore.checkpoint.checkpointOptions,subScore,subScore.scorecardScore,tradeTypes';
const pageSize = 200;

const getCommentText = (task) => {
  const commCount = size(task.comments);
  const dueDate = get(task, 'dueDate');

  let str = '';
  let dueText = null;

  if (commCount > 0) {
    const lastComm = last(task.comments);
    const time = moment(lastComm.updatedAt).fromNow();
    str = `${commCount} comment${commCount > 1 ? 's' : ''} - ${time}`;
  } else {
    str = 'No comments';
  }

  if (dueDate && task.status != taskStringToNum('closed')) {
    const now = moment().endOf('day');
    const ddate = moment(first(dueDate.split('T'))).endOf('day');
    const isDue = ddate.diff(now, 'hours') < 0;
    dueText = (
      <Text type="label_small" italic bold style={isDue ? { color: 'red', marginLeft: 3 } : { marginLeft: 3 }}>
        {isDue ? ` Overdue: ${ddate.fromNow()}` : `Due: ${ddate.fromNow()}`}
      </Text>
    );
  }

  return (
    <Row>
      <Text type="label_small" italic>
        {str}
        {dueText ? ' -' : ''}
      </Text>
      {dueText}
    </Row>
  );
};

export const StatusDrop = (props) => {
  const { item } = props;

  const showDropIcon = get(props, 'showDropIcon', true);

  const options = [
    { title: 'Open', value: 0 },
    { title: 'Pending', value: 1 },
    { title: 'Closed', value: 2 },
  ].map((v) => ({ ...v, selected: get(item, 'status') == v.value, onClick: (e) => props.onSelect(e, v) }));

  return (
    <div style={{ marginBottom: 4 }}>
      <MoreList
        {...props}
        bgColor={'default'}
        onOpen={() => props.onOpen && props.onOpen()}
        onClose={() => props.onClose && props.onClose()}
        buttonProps={{ disabled: props.readOnly, style: { padding: `0px 10px` } }}
        showIcon={false}
        options={options}
        renderButton={() => (
          <Row>
            {getTaskStatus(item).titleCase}
            {showDropIcon && <Icon style={{ marginLeft: 5 }}>arrow_drop_down</Icon>}
          </Row>
        )}
      />
    </div>
  );
};

const TaskItem = withRouter((props) => {
  const classes = useStyles(props);
  const { item, showChecks, expanded, tcid } = props;
  const task = item;
  const [tag, setTag] = useState();
  const status = getTaskStatus(task);
  const image = getTaskImage(task);
  const commText = getCommentText(task);
  const tradeTypes = getTaskTradeTypes(task);
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const dispatch = useDispatch();
  const isSelected = newTasks.find((t) => t.id === task.id);
  const [modalOpen, setModalOpen] = useState(false);
  const [taskDetail, setTaskDetail] = useState({
    open: false,
    useHistory: false,
    onClose: () => {
      setTaskDetail((s) => ({ ...s, open: false }));
      props.onCloseDetail && props.onCloseDetail();
    },
  });
  const [quickEdit, setQuickEdit] = useState({
    open: false,
    onClose: () => {
      setQuickEdit((s) => ({ ...s, open: false }));
      props.onCloseDetail && props.onCloseDetail();
    },
  });
  const [moreOpen, setMoreOpen] = useState(false);

  const onIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSelected) {
      dispatch(removeNewTask(task));
    } else {
      dispatch(addNewTask({ ...task, fromSelected: true }));
    }
  };

  const renderIcon = () => (
    <div className={classes.leftIconWrap}>
      <IconButton onClick={onIconClick} size="large">
        {showChecks || isSelected ? <ScoreIcon useBlankCheckbox={!isSelected} selected={isSelected} /> : <Icon>{status.icon}</Icon>}
      </IconButton>
    </div>
  );

  const d = item;

  const scorecardId = expanded ? get(d, 'scorecardScore.scorecardId', get(d, 'subScore.scorecardScore.scorecardId', null)) : null;
  const scData = useRetrieveData(
    { url: `/scorecards/${scorecardId}` },
    {
      waitFor: scorecardId,
      build: ['scorecards'],
    }
  );
  const scorecard = get(scData, 'data.0');
  const scorecardConfig = get(scData, 'data.0.config');

  const clickItem = () => {
    if (moreOpen) {
      return;
    }

    setTaskDetail((s) => ({
      ...s,
      taskId: item.id,
      open: true,
    }));
  };

  useEffect(() => {
    if (d) {
      if (get(d, 'scorecardScore')) {
        const scs = get(d, 'scorecardScore');
        const cp = get(scs, 'checkpoint');

        setTag({
          scorecardConfig: scorecardConfig,
          ...cp,
          ...scs,
        });
      } else if (get(d, 'subScore')) {
        const { subScore, ...rest } = d;
        setTag({
          ...rest,
          scorecardConfig: scorecardConfig,
          ...get(subScore, 'scorecardScore', {}),
          ...subScore,
        });
      } else {
        setTag();
      }
    }
  }, [d, scorecard]);

  const showRowImages = (image.src || image.icon) && !expanded;

  const handleSelection = (e, selected) => {
    stopProp(e);
    setQuickEdit((q) => ({ ...q, open: true, item: { ...props, task }, selected }));
  };

  const diplayImages = (item.images || []).map((img) => {
    return {
      ...img,
      task,
    };
  });

  return (
    <ListItem
      disableRipple={props.readOnly || !!quickEdit.open || !!modalOpen || !!taskDetail.open || moreOpen}
      key={task.id}
      component={null}
      button
      alignItems={'flex-start'}
      className={classes.ItemContainer}
    >
      <div className={classes.flexrow} onClick={clickItem}>
        {!props.isMobile && renderIcon()}
        <ListItemText
          primary={
            <div className={classes.flexrow}>
              {props.isMobile && renderIcon()}
              <div className={'Title'}>{task.name}</div>
            </div>
          }
          secondary={
            <div className="TextRowContainer">
              <div className="traderow">{tradeTypes ? tradeTypes.map((t) => <span>{t}</span>) : 'None'}</div>
              <div className={classes.textRow}>{get(task, 'description') || ''}</div>
              <div className="daterow">{`${get(task, 'authors.0.name')} - ${moment(task.createdAt).fromNow()}`}</div>
              <div className="daterow">{commText}</div>
            </div>
          }
        />
        <ListItemSecondaryAction className={classes.secondaryAction}>
          <div>
            <StatusDrop item={item} onOpen={() => setMoreOpen(true)} onClose={() => setMoreOpen(false)} onSelect={(e, v) => handleSelection(e, v)} readOnly={props.readOnly} />
            {showRowImages && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                {image.src && <ImageList images={diplayImages} displayAmt={1} showCaption={false} onOpen={() => setModalOpen(true)} onClose={() => setModalOpen(false)} spaceBetween={5} />}
                {image.icon && <Icon classes={{ root: classes.imageIcon }}>{image.icon}</Icon>}
              </div>
            )}
          </div>
        </ListItemSecondaryAction>
      </div>
      {expanded && (
        <div class={clsx(classes.expandContainer, !tag && classes.pad)}>
          {tag && (
            <div className={classes.tagContainer}>
              <RenderTag tag={tag} />
            </div>
          )}
          <div className={classes.imageRow}>
            <ImageList images={diplayImages} onOpen={() => setModalOpen(true)} onClose={() => setModalOpen(false)} spaceBetween={5} />
          </div>
        </div>
      )}
      <DetailModal {...taskDetail} />
      <QuickEditModal {...quickEdit} />
    </ListItem>
  );
});

export const QuickEditModal = (props) => {
  if (!props.open) {
    return null;
  }

  return (
    <Modal {...props} maxWidth={'80%'}>
      <div>
        <TaskItem {...props.item} readOnly />
        <CommentContainer {...props} {...props.item.item} isModal task={get(props, 'item.task')} showComments={false} openInCreate={{ newStatus: taskNumToString(get(props, 'selected.value')) }} />
      </div>
    </Modal>
  );
};

export default withRouter(
  realmChange((props) => {
    const { match } = props;
    const classes = useStyles();
    const [showCreate, setShowCreate] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const filter = useSelector((state) => get(state, 'filter.tasks.realm'));
    const newTasks = useSelector((state) => get(state, 'view.task.new'));
    const [showMessages, setShowMessages] = useState(false);
    const dispatch = useDispatch();
    const vendors = useVendors(undefined, { includeUsersRealm: true, include: 'vendor' });
    const [hstate, sethState] = useState({
      selectAll: false,
      history: false,
      sort: 'modified',
      filter: {
        // status: undefined,
      },
    });
    const [data, setData] = useState([]);
    const [mdata, setMData] = useState([]);
    const { addNewTasks, removeNewTasks, view } = useView();

    const { isMobile } = useScreen();

    const id = get(match, 'params.id', 0);

    const [messageParams, setMessageParams] = useState({ waitFor: null });
    const [urlParams, setUrlParams] = useState({ waitFor: null });

    const sortOptions = [
      !showMessages && { title: 'Updated', value: 'modified', sort: (d) => orderBy(d, 'updatedAt', 'desc') },
      { title: 'Newest', value: 'date_created', sort: (d) => orderBy(d, 'createdAt', 'desc') },
      { title: 'Oldest', value: 'date_oldest', sort: (d) => orderBy(d, 'createdAt') },
      !showMessages && { title: 'Due Date', value: 'due_date', sort: (d) => orderBy(d, 'dueDate') },
      !showMessages && {
        title: 'Trade Type',
        value: 'tradeType',
        sort: (d) => orderBy(d, (i) => (get(i, 'tradeTypes.0.name') || get(i, 'tradeTypes.0.defaultName') || 'zzz').toLowerCase()),
      },
    ].filter((f) => !!f);

    const taskCountItem = useRetrieveData(
      { url: `/processed-task-count-values/${id}` },
      { build: ['processedTaskCountValues'], transformData: (d) => get(d, 0), params: { include: 'realm,realm.parent' } }
    );
    const item = get(taskCountItem, 'data');
    const loca = useLocation();
    const { realmId } = getUrlParams(loca.search);
    const _realmId = get(item, 'realm.id') || realmId;
    const isMy = get(filter, 'ownership') === 'my';

    const filterProps = (type) => {
      if (type === 'message') {
        return {
          include: 'realm,from,model,media,users',
          ...{ page: { size: pageSize, number: 1 } },
          ...buildFilters(
            {
              ...filter,
              realm: _realmId,
              _sort: {
                sortBy: '-created_at',
              },
            },
            {
              includeRealm: false,
              dontFilter: ['name', 'content', 'searchstring', 'ownership', 'status', 'vendor_id', 'age'],
              dontSort: ['-open', '-pending', 'updated_at', 'oldest', 'count'],
            }
          ),
        };
      } else {
        return {
          include,
          ...{ page: isMy ? undefined : { size: pageSize, number: 1 } },
          ...buildFilters(filter, {
            includeRealm: false,
            convertName: { searchstring: 'name', realm_type: 'tier' },
            dontFilter: ['content', 'name'],
            overrideFilter: (filtObj) => {
              if (filtObj.status) {
                set(filtObj, filtObj.status, true);
                delete filtObj.status;
              }
              if (filtObj.vendor_id === 0) {
                delete filtObj.vendor_id;
              }
              set(filtObj, 'onlyRealm', _realmId);
              return filtObj;
            },
            overrideSort: (sort) => {
              return undefined;
            },
          }),
        };
      }
    };

    useEffect(() => {
      if (!_realmId) {
        return;
      }

      setMessageParams({
        build: ['messages'],
        useEffect: true,
        waitFor: showMessages,
        params: filterProps('message'),
      });
      setUrlParams({
        build: ['tasks'],
        useEffect: true,
        waitFor: undefined,
        params: filterProps(),
      });
    }, [filter, _realmId, showMessages]);

    const { data: _data, loading, update, meta } = useRetrieveData({ url: `/tasks` }, urlParams);
    const messages = useRetrieveData({ url: '/messages' }, messageParams);

    const [taskDetail, setTaskDetail] = useState({
      open: false,
      useHistory: false,
      onClose: () => {
        setTaskDetail((s) => ({ ...s, open: false }));
        update({ loading: false });
        clearDetailParam();
      },
    });

    useEffect(() => {
      if (taskCountItem.loading) {
        return;
      }

      messages.update();
    }, [newTasks]);

    useEffect(() => {
      dispatch(setTaskList(data));
    }, [data]);

    useEffect(() => {
      const { detail } = getUrlParams(loca.search);
      if (detail) {
        setTaskDetail((s) => ({ ...s, open: true, taskId: detail }));
      }
    }, []);

    useEffect(() => {
      sethState((h) => ({ ...h, sort: showMessages ? 'date_created' : 'modified' }));
    }, [showMessages]);

    useEffect(() => {
      const dd = uniqBy(showMessages ? messages.data : _data, 'id');
      const hasFilter = Object.hasOwn(hstate.filter, 'status');

      const filteredData =
        !hasFilter || showMessages
          ? dd
          : dd.filter((d) => {
              return size(
                Object.keys(hstate.filter).filter((k) => {
                  const val = hstate.filter[k];
                  return get(d, k) == val;
                })
              );
            });

      const selSort = sortOptions.find((s) => s.value == hstate.sort);

      const meth = showMessages ? setMData : setData;
      meth(selSort.sort(filteredData));
    }, [_data, messages.data, hstate.sort, hstate.filter]);

    useEffect(() => {
      if (hstate.selectAll) {
        addNewTasks(data.map((d) => ({ ...d, fromSelected: true })));
      } else {
        const hasNew = get(view, 'task.new', []).find((t) => !t.fromSelected);
        if (hasNew) {
          return;
        }
        removeNewTasks();
      }
    }, [hstate.selectAll]);

    const clearDetailParam = () => {
      const search = new URLSearchParams(loca.search);
      search.delete('detail');
      props.history.replace(`${loca.pathname}?${search.toString()}`);
    };

    const toggleMessages = async () => {
      setShowMessages(!showMessages);
    };

    const lastPageMessages = get(messages.meta, 'page.last-page', null);
    const lastPageTasks = get(meta, 'page.last-page', null);
    const updatePage = (newPage, params) => {
      if (params === 'messages') {
        if (newPage <= lastPageMessages) {
          setMessageParams({
            ...messageParams,
            params: {
              ...messageParams.params,
              page: { size: pageSize, number: newPage },
            },
          });
        }
      } else if (params === 'tasks') {
        if (newPage <= lastPageTasks) {
          setUrlParams({
            ...urlParams,
            params: {
              ...urlParams.params,
              page: { size: pageSize, number: newPage },
            },
          });
        }
      }
    };

    const getItemOverride = () => {
      const obj = {
        ...item,
        open: 0,
        pending: 0,
        closed: 0,
      };

      if (loading) {
        obj.open = Loading;
        obj.pending = Loading;
        obj.closed = Loading;
      } else {
        _data.map((di) => {
          if (di.status === 0) {
            obj.open += 1;
          } else if (di.status === 1) {
            obj.pending += 1;
          } else if (di.status === 2) {
            obj.closed += 1;
          }
        });
      }

      return obj;
    };

    const changeFilter = (f, key = 'status') => {
      sethState((h) => {
        const filt = { ...h.filter };
        const val = taskStringToNum(f);
        const alreadyHasFilter = get(filt, key) == val;

        if (alreadyHasFilter) {
          unset(filt, key);
        } else {
          set(filt, key, val);
        }

        return {
          ...h,
          filter: { ...filt },
        };
      });
    };

    const renderHeader = () => {
      return (
        <Row className={classes.header}>
          <div className="div1">
            <FormControlLabel
              size="small"
              control={<Checkbox disabled={showMessages} size="small" onChange={(e) => sethState((s) => ({ ...s, selectAll: e.target.checked }))} value={hstate.selectAll} />}
              label="Select All"
            />
          </div>

          <Row className="div2">
            <IconButton color={showMessages ? 'primary' : undefined} onClick={toggleMessages}>
              <Icon>history</Icon>
            </IconButton>
            <IconButton disabled={showMessages} color={expanded ? 'primary' : undefined} onClick={() => setExpanded(!expanded)}>
              <Icon>unfold_more</Icon>
            </IconButton>
            <MoreList
              bgColor={'default'}
              showIcon={false}
              options={sortOptions.map((s) => ({ ...s, selected: get(hstate, 'sort') == s.value, onClick: (e, sel) => sethState((h) => ({ ...h, sort: s.value })) }))}
              renderButton={() => (
                <Row>
                  Sort By<Icon>import_export</Icon>
                </Row>
              )}
            />
          </Row>
        </Row>
      );
    };

    return (
      <GridContainer>
        <LeftSideBar hidden={isMobile}>
          <TaskFilters display={'realm'} vendors={vendors} />
        </LeftSideBar>

        <CenterContent overflowHidden={true}>
          <TaskNotify realmId={_realmId} />
          {isMobile && (
            <div className={classes.padRow}>
              <TaskFilters display={'realm'} vendors={vendors} />
            </div>
          )}
          {item && (
            <List className={classes.noPadding}>
              <TaskListItem {...hstate} changeFilter={changeFilter} destination={`/tasks/list`} item={taskCountItem.data} itemOverride={isMy && getItemOverride()} isHeader={true} />
              <div className={classes.padLeft}>
                <Button
                  disabled={!userHasPermissions('createTasks')}
                  className={classes.button}
                  variant="contained"
                  color="secondary"
                  onClick={() => setShowCreate(true)}
                  startIcon={<Icon>add_a_photo</Icon>}
                >
                  ADD NEW
                </Button>
              </div>
            </List>
          )}

          {showMessages && (
            <MessagesList
              handlePageChange={(np) => updatePage(np, 'messages')}
              currentPage={get(messageParams, 'params.page.number', 1)}
              lastPage={lastPageMessages}
              data={mdata || []}
              alwaysReplaceData
              loading={messages.loading}
              header={renderHeader()}
              isMobile={isMobile}
            />
          )}

          {!showMessages && (
            <TaskList
              handlePageChange={(np) => updatePage(np, 'tasks')}
              currentPage={get(urlParams, 'params.page.number', 1)}
              lastPage={lastPageTasks}
              data={data || []}
              alwaysReplaceData
              loading={loading}
              trackChecks={newTasks}
              expanded={expanded}
              tcid={id}
              header={renderHeader()}
              isMobile={isMobile}
              onCloseDetail={() => {
                update({ loading: false });
                clearDetailParam();
              }}
              {...hstate}
            />
          )}

          {showCreate && (
            <TaskCreate
              open={showCreate}
              onClose={() => {
                update();
                setShowCreate(false);
              }}
              realmItem={{
                realmName: get(item, 'realmName', ''),
                realm: {
                  id: _realmId,
                },
              }}
            />
          )}

          <DetailModal {...taskDetail} />
        </CenterContent>
        <RightSideBar />
      </GridContainer>
    );
  })
);

const MessagesList = withInfiniteScroll(MessageListItem, List);
const TaskList = withInfiniteScroll(TaskItem, List);
